import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnInit, QueryList, ViewChildren } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { BehaviorSubject, switchMap, take } from 'rxjs';
import { UnitCardService } from 'src/app/services/shared/unit-card.service';
import { UtilsService } from 'src/app/services/utils.service';
import { LoggerService } from 'src/app/shared/errors/logger.service';
import { BaseResponseDto, BaseResponseStatus } from 'src/app/shared/models/BaseResponseDto.model';
import { UnitCustomerTokenDto } from 'src/app/shared/models/unit-card/UnitCustomerTokenDto.model';
import { TerraUtils } from 'src/app/shared/TerraUtils';
import { SixDigitCodeInput } from '../../../six-digit-code-input/six-digit-code-input.component';
import { CreateCustomerTokenDialogContext } from './CreateCustomerTokenDialogContext';

@Component({
  selector: 'terra-unit-card-create-customer-token',
  templateUrl: './unit-card-create-customer-token.component.html',
  styleUrls: ['./unit-card-create-customer-token.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitCardCreateCustomerTokenComponent extends OnDestroyMixin implements OnInit, AfterViewInit {

  // consts:
  // PhoneVerificationErrorType = PhoneVerificationErrorType;

  isCodeSent$ = new BehaviorSubject(false);
  isSendingCode$ = new BehaviorSubject(false);
  isSubmitting$ = new BehaviorSubject(false);
  codeControl = new UntypedFormControl(null, Validators.required);
  pageForm = this.fb.group({
    code: this.codeControl
  });

  @ViewChildren('codeInput') codeInputs: QueryList<SixDigitCodeInput>;

  isGeneralServerError$ = new BehaviorSubject(false);
  generalServerErrorMessage = TerraUtils.consts.messages.GENERAL_SUBMIT_ERROR;

  codeVerificationResponse$ = new BehaviorSubject<UnitCustomerTokenDto>(null);

  constructor(
    @Inject(MAT_DIALOG_DATA) public context: CreateCustomerTokenDialogContext,
    public dialogRef: MatDialogRef<UnitCardCreateCustomerTokenComponent>,
    private fb: UntypedFormBuilder,
    private loggerService: LoggerService,
    // private phoneVerificationStrategy: BasePhoneVerificationStrategy,
    private unitCardService: UnitCardService,
    private utilsService: UtilsService) {
      super();
      dialogRef.addPanelClass('terra-unit-card-create-customer-token');
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.focusOnInputWhenItAppears();
  }

  get phoneNUmber(): string {
    return this.context.phone.trim().startsWith('+') ? this.context.phone : `+${this.context.phone}`;
  }

  sendSms() {
    this.isSendingCode$.next(true);
    this.isGeneralServerError$.next(false);
    this.unitCardService.createBusinessVirtualDebitCardVerificationToken().subscribe(response => {
      if(response.responseStatus !== BaseResponseStatus.Success){
        this.utilsService.alertErrorMessage(response as BaseResponseDto);
        return;
      }
      this.codeVerificationResponse$.next(response);
      this.isCodeSent$.next(true);
      this.isSendingCode$.next(false);
    }, error => {
      if (error instanceof BaseResponseDto) {
        this.utilsService.alertErrorMessage(error);
      } else {
        this.loggerService.error('Error in Create UnitCardCreateCustomerTokenComponent => sendSms method.', error);
        this.isGeneralServerError$.next(true);
      }
      this.isSendingCode$.next(false);
    });
  }

  resendSms() {
    this.isGeneralServerError$.next(false);
    this.isSendingCode$.next(true);
    this.unitCardService.createBusinessVirtualDebitCardVerificationToken().subscribe(() => {
      this.isSendingCode$.next(false);
    },
    error => {
      if (error instanceof BaseResponseDto) {
        this.utilsService.alertErrorMessage(error);
      } else {
        this.loggerService.error('Error in Create UnitCardCreateCustomerTokenComponent => resendSms method.', error);
        this.isGeneralServerError$.next(true);
      }
      this.isSendingCode$.next(false);
    });
  }

  continue() {
    this.isGeneralServerError$.next(false);
    // this.codeVerificationResponse$.next(null);
    if (!this.pageForm.valid) {
      return;
    }

    // const request = new UnitCustomerTokenDto();
    // request.verificationCode = this.codeControl.value;
    this.isSubmitting$.next(true);
    this.codeVerificationResponse$.pipe(
      take(1),
      switchMap(request => {
        request.verificationCode = this.codeControl.value;
        return this.unitCardService.createCardCustomerTokenAsync(request)
      })
    )
    .subscribe(
      response => {
        this.codeVerificationResponse$.next(response);
        if (response.error) {
          this.codeControl.reset();
        }
        this.isSubmitting$.next(false);
      },
      error => {
        if (error instanceof BaseResponseDto) {
          this.utilsService.alertErrorMessage(error);
        } else {
          // if invalid code, display a message
          this.codeControl.reset();
          this.isGeneralServerError$.next(true);
        }
        this.isSubmitting$.next(false);
        console.log(error);
      }
    );
  }

  private focusOnInputWhenItAppears() {
    this.codeInputs.changes.pipe(untilComponentDestroyed(this)).subscribe(x => {
      if (this.codeInputs?.first) {
        this.codeInputs.first.onContainerClick();
      }
    });
  }



}
